import * as actionTypes from './actionTypes';
import { UserValuesService } from '@app/src/views/EditUser/editUser/models/UserValues';
import * as actionTypesSidebar from '@app/src/commons/sidebar/state/sidebar/actionTypes';

interface State {
  isFetching: boolean;
  errorMessage: string;
  data: UserValuesService;
  idUser: number;
  errorRol: boolean;
}

const initialState = {
  data: {
    name: '',
    lastname: '',
    email: '',
    rol: 0,
    state: 0
  },
  idUser: null,
  isFetching: false,
  errorMessage: '',
  errorRol: false
};

export const filterEditUserValues = (state: State = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_FILTER_VALUES_REQUEST:
      return {
        ...state,
        data: {
          name: '',
          lastname: '',
          email: '',
          rol: 0,
          state: 0
        },
        isFetching: true,
        errorMessage: '',
        errorRol: false
      };

    case actionTypes.FETCH_FILTER_VALUES_FAILURE:
      return {
        ...state,
        errorMessage: action.errorMessage,
        isFetching: false,
        errorRol: action.errorRol
      };

    case actionTypes.FETCH_FILTER_VALUES_SUCCESS:
      return {
        ...state,
        data: action.data,
        isFetching: false,
        errorMessage: '',
        errorRol: false
      };

    case actionTypes.FETCH_GET_IDUSER:
      return {
        ...state,
        idUser: action.idUser
      }

    case actionTypesSidebar.RESET_APP_STATE:
      return initialState;
    default:
      return state;
  }
}
